export { default as generate } from "./generate";
export * from "./presets";
export * from "./types";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/colors/es/index.js
// module id = 89
// module chunks = 0